import { render, staticRenderFns } from "./consumptionNum.vue?vue&type=template&id=e958641e&scoped=true"
import script from "./consumptionNum.vue?vue&type=script&lang=js"
export * from "./consumptionNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e958641e",
  null
  
)

export default component.exports